export default "__VITE_ASSET__BpmpCgaK__"